import { DATABASE_BE_STREAMING_PARTICIPANT } from '@databases/database-ai-first-creation-state';
import { type Participant } from '@databases/presence';

import { getAiFieldStreamingParticipants } from './get-ai-field-streaming-participants.ts';

interface GetRowCollaboratorColorOptions {
  participants: Participant[];
  recentCollaboratorColor: string | undefined;
  isAiFieldStreaming: boolean;
  isProgressivelyRevealed: boolean;
}

export const getEntryPresenceBorderColor = ({
  participants,
  recentCollaboratorColor,
  isAiFieldStreaming,
  isProgressivelyRevealed
}: GetRowCollaboratorColorOptions): string | undefined =>
  isProgressivelyRevealed
    ? participants.find(
        ({ identity }) =>
          identity.accountId === DATABASE_BE_STREAMING_PARTICIPANT.identity.accountId
      )?.colorToken
    : isAiFieldStreaming
      ? getAiFieldStreamingParticipants({
          participants,
          shouldExcludeAiAgent: true
        })[0]?.colorToken
      : recentCollaboratorColor;
